import "./App.css";
import Navbar from "./Components/Navbar";
import Product1 from "./Components/Product1";
import Product2 from "./Components/Product2";
import Product3 from "./Components/Product3";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Main from "./Components/Main";
import Aboutus from "./Components/Aboutus";
import Contact from "./Components/Contact";
import Products from "./Components/Products";
import Home from "./Components/Home";
import Cart from "./Components/Cart";
import Home1 from "./Components/Home1";
import Home2 from "./Components/Home2";
import Productpage from "./Components/Productpage";



function App() {
  return (
    <Router basename="/Shri-Shyam-Decor">
      <Navbar />

      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/product" element={<Productpage/>} />
        <Route path="/prod" element={<Home/>} />
        <Route path="/prod2" element={<Home1/>} />
        <Route path="/prod3" element={<Home2/>} />
        <Route path="/about" element={<Aboutus />} />
        <Route path="/Cart" element={<Cart/>} />
      </Routes>
      <Contact />
    </Router>
  );
}

export default App;
